import styled, { css } from 'styled-components';
import { getTransition, getSpace, mq, getColor, getGridSpans } from '../../../stylesheets/tools';

const StyledBanner = styled.div`
  position: relative;
  width: 100%;
  background: linear-gradient(
    315deg,
    ${props => props.theme.globalTheme.primary} 7px,
    rgba(0, 0, 0, 0.8) 0
  );
  z-index: 2;

  ${mq('m')} {
    text-align: center;
  }

  ${mq('l')} {
    background: linear-gradient(315deg, transparent 7px, rgba(0, 0, 0, 0.8) 0);
  }

  .banner__title {
    display: inline-flex;
    align-items: center;
    color: ${getColor('white')};
    cursor: pointer;

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }

    svg {
      margin-left: 10px;
      ${getTransition('defaultFast')}
    }

    &:hover svg {
      transform: translateY(1px);
    }
  }

  .banner__content {
    opacity: 0;
    max-height: 0;
    overflow: hidden; /* Required to clip content during max-height transition */
    ${getTransition('defaultFast')};
    transform: translateY(10px);
    color: ${getColor('white')};
    pointer-events: none;

    /* Override the library's default [hidden] attribute so CSS transitions work */
    &[hidden] {
      display: block;
    }
  }

  .banner__copy a {
    color: ${getColor('white')};
    border-color: ${getColor('white')};

    &:after {
      background-image: url("data:image/svg+xml,%3Csvg width='15' height='15' viewBox='0 0 15 15' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23fff' d='M11.514 2.2H6.786a1 1 0 1 1 0-2h7a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0V3.756L1.907 14.635a1 1 0 0 1-1.414-1.414L11.513 2.2z'/%3E%3C/svg%3E");
    }
  }

  .banner__item {
    ${getGridSpans('width', { s: 12, m: 10 })};
    margin: 0 auto;
    padding: ${getSpace('m')} 0;
  }

  ${props =>
    props.isOpen &&
    css`
      background: linear-gradient(
        315deg,
        ${props.theme.globalTheme.primary} 7px,
        rgba(0, 0, 0, 1) 0
      );

      ${mq('l')} {
        background: linear-gradient(315deg, transparent 7px, rgba(0, 0, 0, 1) 0);
      }

      .banner__title {
        svg {
          transform: rotateX(180deg);
        }

        &:hover svg {
          transform: translateY(-1px) rotateX(180deg);
        }
      }

      .banner__content {
        opacity: 1;
        max-height: 500px;
        transform: translateY(0);
        pointer-events: auto;
      }
    `}

  @media print {
    .banner__content {
      display: block;
      opacity: 1;
      max-height: none;
    }
  }
`;

export default StyledBanner;
